import apiClient from '@/api/apiClient';
import type { Regulator } from '@/types/regulators';

const regulatorsApi = {
  // The regulators offered for the given country (COAF omitted server-side).
  async list(country = 'br'): Promise<Regulator[]> {
    return apiClient.get('/regulators', { params: { country } });
  },

  // Regulators offered when scoping a policy: the account's connected regulators, or every
  // regulator for the country when the account has none connected.
  async listForAccount(country = 'br'): Promise<Regulator[]> {
    return apiClient.get('/regulators/for-account', { params: { country } });
  },
};

export default regulatorsApi;
